export default __webpack_public_path__ + "static/media/Group 607@2x.39821111.png";